import { z } from "zod";
import { isoDateSchema, objectIdSchema } from "./common";
export const templateSchema = z.object({
    _id: objectIdSchema,
    userId: objectIdSchema,
    name: z.string().min(1).max(120),
    body: z.string().min(1).max(1600), // may contain {{variables}}
    createdAt: isoDateSchema,
});
export const createTemplateSchema = z.object({
    name: z.string().min(1).max(120),
    body: z.string().min(1).max(1600),
});
export const updateTemplateSchema = createTemplateSchema.partial();
export const previewTemplateSchema = z.object({
    variables: z.record(z.string(), z.string()).default({}),
});
const TEMPLATE_VAR_PATTERN = /\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g;
export function extractTemplateVariables(body) {
    const names = new Set();
    for (const match of body.matchAll(TEMPLATE_VAR_PATTERN)) {
        const name = match[1];
        if (name)
            names.add(name);
    }
    return [...names];
}
export function renderTemplate(body, variables) {
    return body.replace(TEMPLATE_VAR_PATTERN, (_match, name) => variables[name] ?? "");
}
//# sourceMappingURL=template.js.map